import { render, staticRenderFns } from "./struggle-comp-card.vue?vue&type=template&id=309470be"
import script from "./struggle-comp-card.ts?vue&type=script&lang=ts&external"
export * from "./struggle-comp-card.ts?vue&type=script&lang=ts&external"
import style0 from "./struggle-comp-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports